export function assignModelProperties(target, source, defaults, removeDefaults?) {
  for (var key in defaults) {
    if (!defaults.hasOwnProperty(key)) {
      continue;
    }

    target[key] = source[key] === undefined ? defaults[key] : source[key];
  }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./public/app/core/utils/model_utils.ts